import EntityNotificationsEdit from './EntityNotificationsEdit';

export default EntityNotificationsEdit;
